export class GetImageProfile {
    constructor(ImageProfileRepository) {
      this.ImageProfileRepository = ImageProfileRepository;
    }
  
    async execute(companyId) {
        console.log('GetImageProfile - companyId : '+ companyId)
      return await this.ImageProfileRepository.getImageProfile(companyId);
    }
  }